<template>
  <div>
    <Certificate />
  </div>
</template>

<script>
import Certificate from "../../../components/adminComponent/achievement/certificatemanagement/Certificate";
export default {
  name: "CertificateManagement",
  components: {
    Certificate
  }
};
</script>
